module.exports = __webpack_public_path__ + "static/img/lrs_langren_img@2x.f4b6720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lrsimages/rules/lrs_langren_img@2x.png
// module id = gJUu
// module chunks = 23